import { render, staticRenderFns } from "./NeedsDashboard.vue?vue&type=template&id=628e50f8&scoped=true&"
import script from "./NeedsDashboard.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsDashboard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628e50f8",
  null
  
)

export default component.exports